import { Component } from '@angular/core';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-durationselect',
  templateUrl: './durationselect.component.html',
  styleUrls: ['./durationselect.component.css']
})
export class DurationselectComponent {

}
